import { render, staticRenderFns } from "./TSFluxItemsTable.vue?vue&type=template&id=057c4b13&scoped=true&"
import script from "./TSFluxItemsTable.vue?vue&type=script&lang=js&"
export * from "./TSFluxItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./TSFluxItemsTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TSFluxItemsTable.vue?vue&type=style&index=1&id=057c4b13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057c4b13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VDataTable,VIcon})
